"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _actions = require("./redux/actions");

var _selectors = require("./redux/selectors");

var _Menu = _interopRequireDefault(require("./Menu"));

var _utils = require("../../utils");

var _ExportHTMLModal = _interopRequireDefault(require("../common/ExportHTMLModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function exportHTML(exportedJSON) {
  return exportedJSON && exportedJSON.length > 0 ? exportedJSON.map(function (menu, i) {
    return "" + "<p>Banners for mega menu ".concat(i + 1, "</p>\n") + "<div class=\"navPage-subMenu-rightBanners\" id=\"emthemesModezBannersBlockMegaMenuRight".concat(i, "\">\n") + (menu.rightRegion.bannerGroups && menu.rightRegion.bannerGroups.length > 0 ? menu.rightRegion.bannerGroups.map(function (bannerGroup, j) {
      return "" + (bannerGroup.banners && bannerGroup.banners.length > 0 ? bannerGroup.banners.map(function (_ref, k) {
        var _ref$link = _ref.link,
            link = _ref$link === void 0 ? '' : _ref$link,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? '' : _ref$alt,
            _ref$img = _ref.img,
            img = _ref$img === void 0 ? '' : _ref$img;
        return "" + "<a class=\"column\" href=\"".concat((0, _utils.htmlEntities)(link), "\"><img src=\"").concat((0, _utils.htmlEntities)(img), "\" alt=\"").concat((0, _utils.htmlEntities)(alt), "\" /></a>\n");
      }).join('') : '');
    }).join('') : '') + "</div>\n" + "<div class=\"navPage-subMenu-bottomBanners\" id=\"emthemesModezBannersBlockMegaMenuBottom".concat(i, "\">\n") + (menu.bottomRegion.bannerGroups && menu.bottomRegion.bannerGroups.length > 0 ? menu.bottomRegion.bannerGroups.map(function (bannerGroup, j) {
      return "" + "<p class=\"row\">\n" + (bannerGroup.banners && bannerGroup.banners.length > 0 ? bannerGroup.banners.map(function (_ref2, k) {
        var _ref2$link = _ref2.link,
            link = _ref2$link === void 0 ? '' : _ref2$link,
            _ref2$alt = _ref2.alt,
            alt = _ref2$alt === void 0 ? '' : _ref2$alt,
            _ref2$img = _ref2.img,
            img = _ref2$img === void 0 ? '' : _ref2$img;
        return "" + "<a class=\"column\" href=\"".concat((0, _utils.htmlEntities)(link), "\"><img src=\"").concat((0, _utils.htmlEntities)(img), "\" alt=\"").concat((0, _utils.htmlEntities)(alt), "\" /></a>\n");
      }).join('') : '') + "</p>\n";
    }).join('') : '') + "</div>\n";
  }).join('') : '';
}

var MenuBuilder = function MenuBuilder(_ref3) {
  var menus = _ref3.menus,
      collapsed = _ref3.collapsed,
      exportedJSON = _ref3.exportedJSON,
      toggleCollapse = _ref3.toggleCollapse,
      createMenu = _ref3.createMenu,
      exportJSON = _ref3.exportJSON,
      resetState = _ref3.resetState;

  var _useState = (0, _react.useState)((0, _utils.uniqueElementId)()),
      _useState2 = _slicedToArray(_useState, 1),
      elId = _useState2[0];

  var _useState3 = (0, _react.useState)((0, _utils.uniqueElementId)()),
      _useState4 = _slicedToArray(_useState3, 1),
      modalId = _useState4[0];

  var exportedHTML = exportHTML(exportedJSON);
  return (
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "MenuBuilder"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card mb-4"
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-header"
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-outline-secondary btn-icon mr-3 ".concat(collapsed ? 'collapsed' : ''),
      type: "button",
      onClick: function onClick() {
        return toggleCollapse();
      },
      "aria-expanded": "true",
      "aria-controls": "#".concat(elId, "-body, #").concat(elId, "-footer")
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "expand_more")), "Edit Mega Menu Banners"),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-body collapse ".concat(!collapsed ? 'show' : ''),
      id: "".concat(elId, "-body")
    }, menus.map(function (menu, i) {
      return (
        /*#__PURE__*/
        _react["default"].createElement(_Menu["default"], _extends({
          key: "Menu-".concat(menu.id),
          index: i
        }, menu))
      );
    })),
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: "card-footer collapse ".concat(!collapsed ? 'show' : ''),
      id: "".concat(elId, "-footer")
    },
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-primary btn-icon",
      onClick: function onClick() {
        return createMenu();
      }
    },
    /*#__PURE__*/
    _react["default"].createElement("i", {
      className: "material-icons"
    }, "add"), " Add Menu"),
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-primary ml-2",
      onClick: function onClick() {
        return exportJSON();
      },
      "data-toggle": "modal",
      "data-target": "#".concat(modalId)
    }, "Export HTML"),
    /*#__PURE__*/
    _react["default"].createElement("button", {
      className: "btn btn-sm btn-secondary ml-2",
      onClick: function onClick() {
        return resetState();
      }
    }, "Reset to default"))),
    /*#__PURE__*/
    _react["default"].createElement(_ExportHTMLModal["default"], {
      id: modalId,
      exportedHTML: exportedHTML
    }))
  );
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    menus: (0, _selectors.getMenus)(state),
    collapsed: (0, _selectors.getCollapsed)(state),
    exportedJSON: (0, _selectors.getExportedJSON)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  toggleCollapse: _actions.toggleCollapse,
  createMenu: _actions.createMenu,
  exportJSON: _actions.exportJSON,
  resetState: _actions.resetState
})(MenuBuilder);

exports["default"] = _default;